import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Für Navigation nach dem Logout

const LogoutPage = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/pages/login'); // Zur Login-Seite navigieren
  };

  return (
    <Box
      sx={{
        padding: '2rem',
        maxWidth: '600px',
        margin: '30vh auto',
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" gutterBottom>
      Sie wurden erfolgreich abgemeldet.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Vielen Dank, dass Sie unser System genutzt haben.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLoginRedirect}>
        Zur Login-Seite
      </Button>
    </Box>
  );
};

export default LogoutPage;
